import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  GetSiteTranslatablesPropertiesOptions,
  GetSiteTranslatablesPropertiesResponse,
  Locale,
  TranslateSiteOptions,
  getSiteTranslatablesProperties as universalGetSiteTranslatablesProperties,
  translateSite as universalTranslateSite,
} from './multilingual-sitetranslator-v2-site-translatable-properties-site-translator.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/multilingual' };

export function translateSite(httpClient: HttpClient): TranslateSiteSignature {
  return (
    mainLanguage: Locale,
    options: NonNullablePaths<TranslateSiteOptions, `translatedLanguage`, 2>
  ) =>
    universalTranslateSite(
      mainLanguage,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface TranslateSiteSignature {
  /**
   * Start a task to auto-translate all site content that hasn't been translated yet
   * @param - Language from which the site content is translated
   */
  (
    mainLanguage: Locale,
    options: NonNullablePaths<TranslateSiteOptions, `translatedLanguage`, 2>
  ): Promise<void>;
}

export function getSiteTranslatablesProperties(
  httpClient: HttpClient
): GetSiteTranslatablesPropertiesSignature {
  return (
    mainLanguage: Locale,
    options?: GetSiteTranslatablesPropertiesOptions
  ) =>
    universalGetSiteTranslatablesProperties(
      mainLanguage,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface GetSiteTranslatablesPropertiesSignature {
  /**
   * Receive the site's translation status
   * @param - Number of words included in main_language
   */
  (
    mainLanguage: Locale,
    options?: GetSiteTranslatablesPropertiesOptions
  ): Promise<
    NonNullablePaths<
      GetSiteTranslatablesPropertiesResponse,
      | `data.totalWords`
      | `data.translatedWords`
      | `data.machineTranslationWordsUsed`
      | `data.machineTranslateWordsLimit`
      | `data.applicationProperties`
      | `data.applicationProperties.${number}.appId`
      | `data.applicationProperties.${number}.applicationTotalWords`
      | `data.applicationProperties.${number}.applicationTranslatedWords`,
      5
    >
  >;
}

export {
  ApplicationTranslatableProperties,
  GetSiteTranslatablesPropertiesOptions,
  GetSiteTranslatablesPropertiesRequest,
  GetSiteTranslatablesPropertiesResponse,
  Locale,
  SiteTranslatableProperties,
  TranslateSiteOptions,
  TranslateSiteRequest,
  TranslateSiteResponse,
} from './multilingual-sitetranslator-v2-site-translatable-properties-site-translator.universal.js';
